/**
 * A faixa por cima da página quando o plano está pendente ou perto de vencer (no casco vai no
 * espaço `avisos`, logo abaixo do cabeçalho). Com o plano pendente leva «Pagar agora», que
 * abre as subscrições da empresa.
 */
import React from "react";
import { usePage } from "@inertiajs/react";
import { Clock, Info, Wallet } from "lucide-react";
import { cn } from "@/lib/utils";
import { Botao } from "@/Logigate/ui";

interface PlanoBloqueadoBannerProps {
    nivel: "warning" | "pendente" | "readonly" | "blocked";
    diasVencido: number;
    mensagem: string;
    facturaCodigo?: string | null;
    urlPagamento: string;
    planoAtivo: boolean;
    diasParaVencer: number;
}

export default function PlanoBloqueadoBanner({ nivel, mensagem, facturaCodigo }: PlanoBloqueadoBannerProps) {
    const { base_path } = usePage().props as any;
    const pendente = nivel === "pendente";

    const aspecto = pendente
        ? {
            titulo: "Plano pendente",
            icone: <Clock className="size-[18px]" aria-hidden />,
            faixa: "border-blue-200 bg-blue-50 text-blue-950 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-50",
            chip: "bg-blue-100 text-blue-700 dark:bg-blue-500/20 dark:text-blue-300",
        }
        : {
            titulo: "Plano a vencer",
            icone: <Info className="size-[18px]" aria-hidden />,
            faixa: "border-amber-200 bg-amber-50 text-amber-950 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-50",
            chip: "bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300",
        };

    return (
        <div role="status" className={cn("border-b", aspecto.faixa)}>
            <div className="mx-auto flex w-full max-w-[1600px] flex-wrap items-center gap-x-3 gap-y-2.5 px-3 py-2.5 sm:flex-nowrap sm:px-6 lg:px-8">
                <span className={cn("flex size-8 shrink-0 items-center justify-center rounded-lg", aspecto.chip)}>{aspecto.icone}</span>
                <div className="min-w-0 flex-1 text-[13px] leading-snug">
                    <p>
                        <span className="font-semibold">{aspecto.titulo}</span>
                        {mensagem && <span className="opacity-80"> · {mensagem}</span>}
                    </p>
                    {facturaCodigo && (
                        <p className="mt-0.5 text-xs opacity-70">
                            Factura <span className="font-semibold tabular-nums">{facturaCodigo}</span>
                        </p>
                    )}
                </div>
                {pendente && (
                    <Botao
                        cor="blue"
                        tamanho="sm"
                        icone={<Wallet className="size-4" />}
                        href={`${base_path}/subscricoes`}
                        className="h-11 w-full sm:h-8 sm:w-auto"
                    >
                        Pagar agora
                    </Botao>
                )}
            </div>
        </div>
    );
}
